import { Sunrise, Sun, Moon, Clock3 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { GARDEN_MOODS, landscapePath, type GardenChoice } from '../config/garden';

const icons = { mist: Sunrise, autumn: Sun, moon: Moon };
export function GardenMoodPicker({ value, onChange }: { value: GardenChoice; onChange: (mood: GardenChoice) => void }) {
  const { t } = useTranslation();
  return <div className="mood-picker" role="group" aria-label={t('personal.sky')}>
    <button className={`mood-choice mood-auto ${value === 'auto' ? 'selected' : ''}`} aria-pressed={value === 'auto'} onClick={() => onChange('auto')} data-testid="mood-auto"><span><Clock3 size={15} /><span>{t('personal.moods.auto')}</span></span></button>
    {GARDEN_MOODS.map(mood => {
      const Icon = icons[mood];
      return <button key={mood} className={`mood-choice ${value === mood ? 'selected' : ''}`} aria-pressed={value === mood} onClick={() => onChange(mood)} data-testid={`mood-${mood}`}>
        <span className="mood-thumbnail" style={{ backgroundImage: `url(${landscapePath(mood)})` }} aria-hidden="true" />
        <span><Icon size={15} /><span>{t(`personal.moods.${mood}`)}</span></span>
      </button>;
    })}
  </div>;
}
